/**
 * containerStyle: Checkbox's containerStyle    object
 * inputStyle: Checkbox's inputStyle    object
 * labelStyle: Checkbox's labelStyle    object
 * name: Checkbox's name    string
 * value: Checkbox's value    boolean(필수)
 * onChange: Checkbox's onChange    function(필수)
 * disabled: Checkbox's disabled    boolean
 *
 */

import React from "react";

function BasicCheckbox({
  containerStyle,
  inputStyle,
  labelStyle,
  name,
  value,
  onChange,
  disabled,
}) {
  const inputRef = React.useRef(null);

  const CheckboxChange = (e) => {
    onChange(e);
  };

  return (
    <div className="check_wrap" style={containerStyle}>
      <input
        id="check_btn"
        ref={inputRef}
        style={inputStyle}
        type="checkbox"
        checked={value}
        onChange={CheckboxChange}
        disabled={disabled}
      />
      <label
        style={labelStyle}
        onClick={() => {
          onChange({
            target: { checked: !inputRef.current.checked },
          });
        }}
      >
        <span>{name}</span>
      </label>
    </div>
  );
}

BasicCheckbox.defaultProps = {
  disabled: false,
};

export default BasicCheckbox;
